import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import PageSeo from "../Seo/PageSeo";

const AdminOnlyRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="text-sm text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  const isAdmin =
    userProfile?.is_admin === true ||
    userProfile?.role === "admin" ||
    userProfile?.user_type === "admin";

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <PageSeo title="Admin" path={location.pathname} noindex />
      {children}
    </>
  );
};

export default AdminOnlyRoute;
